<template>
  <div>
    <div class="enter">
      <!-- 1.行业数据 -->
      <div class="right">
        <img
          style="height: 320px; width: 100%; overflow: hidden"
          src="../../assets/hysj.png"
          alt=""
        />
      </div>
    </div>
    <!-- 导航 -->
    <navigate :daohangshuju="daohangshuju" />
    <div class="text1 contentCss">
      <h3></h3>
      <p style="margin-top: 15px"></p>
      <h3 style="margin-top: 15px"></h3>
      <p></p>
    </div>
    <div class="daohangjianjie contentCss">
      <div class="threeBox">
        <div class="text">
          <h4>行业评价认证</h4>
          <p>
            深耕电力行业多年，中电联积累了大量行业认证数据，包括质量管理体系认证、能源管理体系认证、信息安全管理体系认证、机电产品认证、光伏运行与维护管理星级评审(5A)、供电服务认证、电力企业合规管理体系认证、项目质量管理体系认证等十四种电力行业体系认证。
          </p>
        </div>
        <div class="text">
          <h4>行业平台</h4>
          <p>
            作为中电联旗下专业电力行业数据平台，提供全面及时的行业数据、专业权威的行业报告及咨询服务。平台内容涵盖行业报告、行业数据、电煤指数(CECI指数)、电力标准等，高效地支撑着电力行业市场研究、咨询、信息化建设等工作。<el-link
              type="primary"
              :underline="false"
              href="https://fw.cec.org.cn/"
              target="_blank"
              ><span class="licxCss">立即查询>></span></el-link
            >
          </p>
        </div>
      </div>
    </div>

    <div class="product contentCss">
      <div class="text">
        <h4>行业报告</h4>
        <p>
          行业发展报告、电力市场报告、电力燃料报告、低碳环保报告、供需分析报告、国际合作报告、会员服务报告、电力信用报告、数字化报告、杂志期刊报告、大事年鉴报告等19类报告。
        </p>
      </div>
      <div class="text">
        <h4>行业数据</h4>
        <p>
          行业统计数据、国际电力数据、电力工程数据、电力可靠性数据、行业对标数据、认证评价数据、科技创新数据、工程计经数据、电力人才数据等9类数据。
        </p>
      </div>
      <div class="text">
        <h4>电煤指数</h4>
        <p>曹妃甸指数、沿海电煤指数、进口煤指数、采购经理人指数。</p>
      </div>
    </div>
  </div>
</template>

<script>
import xdcPng from '@/assets/xdc.png'
import ckPng from '@/assets/logo.png'
import srcImg from '@/assets/xdc1.png'
import HoverImage from "@/components/HoverImage/index"
// 导航组件
import navigate from '@/components/navigate'
export default {
  name: 'vuecomponent',
  components: {
    HoverImage,
    navigate
  },
  data () {
    return {
      xdcPng: xdcPng,
      ckPng,
      searchInput: '',
      bannerList: [
        {
          id: 1,
          content: 'https://www.cecdlzx.com/oss/owms/26E5A26B9230CD01A4B1A1C44EC225BD/257f8ab88f9445b98f9c2826c3203e45.png',
          url: "https://www.cecdlzx.com/owms/#/home"
        },
        {
          id: 2,
          content: 'https://www.cecdlzx.com/oss/owms/26E5A26B9230CD01A4B1A1C44EC225BD/576e0a8c10f1459797aced9ca904efd1.png',
          url: "https://www.cecdlzx.com/dlzx/#/electric"
        },
        {
          id: 3,
          content: 'https://www.cecdlzx.com/oss/owms/26E5A26B9230CD01A4B1A1C44EC225BD/77b7d0be5ebc43ad94854b7863386d4c.png',
          url: "https://www.cecdlzx.com/dlzx/#/login"
        },
      ],
      key: "value",
      srcImg,
      daohangshuju: '电力大数据',
    }
  }
}
</script>

<style lang="less" scoped>
.bannerImg {
  height: 260px;
}

.text1 {
  padding: 0 10px;
}
.product {
  margin-bottom: 60px;
  .h3Text {
    font-size: 24px;
    font-weight: 400;
    text-align: center;
    color: rgba(58, 58, 74, 1);
    margin-top: 30px;
  }
  .text {
    // margin: 15px;
    padding: 10px;
    h4 {
      color: #005ba3;
      margin-top: 10px;
      margin-bottom: 10px;
      font-size: 16px;
    }
    p {
      margin: 0 0 5px;
      line-height: 24px;
    }
  }
}

.partner {
  // margin: 10px 0;

  .title {
    text-align: center;
    position: relative;

    p {
      font-size: 48px;
      font-weight: bold;
      color: rgba(153, 154, 155, 0.3);
    }

    h2 {
      font-size: 36px;
      position: absolute;
      margin: 0;
      left: 45%;
      top: 35px;
    }
  }

  .list {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
    align-items: center;

    span {
      width: 150px;
      height: 60px;
    }
  }
}

.enter {
  overflow: hidden;
  position: relative;
  // padding: 10px;
  width: 100%;
  height: 350px;
  .right {
    width: 100%;
  }
  .last {
    margin-left: 80px;
    width: 100%;
    position: absolute;
    top: 260px;
    .smallBox {
      font-size: 16px;
      width: 180px;
      height: 50px;
      color: #fff;
      border-radius: 5px;
      padding: 10px;
      text-align: center;
      line-height: 45px;
      height: 60px;
      border: 2px solid #53aee7;
      background: #53aee7;
      box-shadow: 0 1px 1px #53aee7, 0 2px 2px #53aee7, 0 3px 3px #53aee7,
        0 4px 4px #53aee7, 0 5px 5px #53aee7;
      transform-origin: 50% 50%;
      /* 设置过渡动画 */
      transition: all 1s;
    }
  }
}
.smallBox:hover {
  /* 鼠标移动上去后  */
  transform: scale(1.2, 1.2);
}
.xdcSearch {
  margin: 10px auto;
  height: 45px;
  line-height: 45px;
  border-radius: 5px;
  text-align: center;
  border: 1px solid #53aee7;
  width: 150px;
}

.daohangjianjie {
  // margin-top: 60px;
  // margin-bottom: 60px;
  .h3Text {
    font-size: 30px;
    font-weight: 400;
    text-align: center;
    color: rgba(58, 58, 74, 1);
    margin-top: 30px;
  }
  .threeBox {
    display: flex;
    justify-content: space-around;
    .text {
      position: relative;
      flex: 1;
      color: rgba(58, 58, 74, 1);
      box-shadow: 0px 1px 4px 0px rgba(0, 120, 255, 0.2);
      border-radius: 4px;
      margin: 30px;
      padding: 12px;
      transform-origin: 50% 50%;
      /* 设置过渡动画 */
      transition: all 1s;
      h4 {
        // margin-top: 40px;
        margin-bottom: 20px;
        font-weight: 700;
        font-size: 16px;
        text-align: center;
      }
      p {
        margin: 0 0 10px;
        line-height: 24px;
      }
      .DetailBtn {
        margin-top: 20px;
        text-align: center;
      }

      .titleImg,
      .titleImg1 {
        padding: 10px;
        border: 1px solid #409eff;
        border-radius: 50%;
        position: absolute;
        top: -35px;
        left: 43%;
      }
    }
    .text:hover {
      /* 鼠标移动上去后  */
      transform: scale(1.1, 1.1);
      background-color: #e8f0fe;
    }
  }
}
</style>
